import axios from 'axios';

const zrusitZadost = (idzadosti: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${idzadosti}/zrusit`
    });
};

export default zrusitZadost;
